var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "web-agent-tab" }, [
    _c("div", { staticClass: "web-agent-tab-layout" }, [
      !_vm.webAgentSettings
        ? _c("div", { staticClass: "no-settings-container" }, [
            _c(
              "div",
              { staticClass: "info-panel" },
              [
                _c("h3", [_vm._v("Web Voice Agent")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                    Web Voice Agent, web sitenize entegre edebileceğiniz konuşma tabanlı bir AI asistanıdır.\n                    Ziyaretçileriniz, web sitenizde ses aracılığıyla AI ajanınızla etkileşime geçebilirler.\n                "
                  ),
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "PermissionController",
                  { attrs: { permissions: ["voice-agent.create"] } },
                  [
                    _c(
                      "supsis-button",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.createWebAgent },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("add"),
                        ]),
                        _vm._v(
                          " Web Voice Agent Oluştur\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _c("div", { staticClass: "settings-container" }, [
            _c("div", { staticClass: "settings-layout" }, [
              _c(
                "div",
                { staticClass: "settings-form" },
                [
                  _c(
                    "a-form",
                    { attrs: { layout: "vertical", form: _vm.form } },
                    [
                      _c("div", { staticClass: "settings-section" }, [
                        _c(
                          "div",
                          {
                            staticClass: "section-header",
                            class: { open: _vm.isSectionOpen("general") },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSection("general")
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("settings"),
                              ]),
                              _vm._v(" "),
                              _c("h3", [_vm._v("Genel Ayarlar")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "i",
                              { staticClass: "material-icons toggle-icon" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isSectionOpen("general")
                                      ? "keyboard_arrow_up"
                                      : "keyboard_arrow_down"
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isSectionOpen("general"),
                                expression: "isSectionOpen('general')",
                              },
                            ],
                            staticClass: "section-content",
                          },
                          [
                            _c(
                              "a-row",
                              { attrs: { gutter: 16 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Durum" } },
                                      [
                                        _c("a-switch", {
                                          attrs: {
                                            "checked-children": "Aktif",
                                            "un-checked-children": "Pasif",
                                          },
                                          model: {
                                            value: _vm.formData.enabled,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "enabled",
                                                $$v
                                              )
                                            },
                                            expression: "formData.enabled",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Konumlandırma" } },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            model: {
                                              value: _vm.formData.position,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "position",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.position",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              {
                                                attrs: {
                                                  value: "bottom-right",
                                                },
                                              },
                                              [_vm._v("Sağ Alt Köşe")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select-option",
                                              {
                                                attrs: { value: "bottom-left" },
                                              },
                                              [_vm._v("Sol Alt Köşe")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select-option",
                                              {
                                                attrs: {
                                                  value: "bottom-middle",
                                                },
                                              },
                                              [_vm._v("Alt Orta")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-row",
                              { attrs: { gutter: 16 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Buton Metni" } },
                                      [
                                        _c("a-input", {
                                          attrs: { placeholder: "Voice Chat" },
                                          model: {
                                            value: _vm.formData.buttonText,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "buttonText",
                                                $$v
                                              )
                                            },
                                            expression: "formData.buttonText",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "İkon Tipi" } },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            model: {
                                              value: _vm.formData.icon,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "icon",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.icon",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "phone" } },
                                              [_vm._v("Telefon")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "avatar" } },
                                              [_vm._v("Avatar")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "custom" } },
                                              [_vm._v("Özel İkon")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-row",
                              { attrs: { gutter: 16 } },
                              [
                                _c("a-col", { attrs: { span: 24 } }, [
                                  _c("h4", [
                                    _vm._v("Kenar Boşlukları (piksel)"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Üstten" } },
                                      [
                                        _c("a-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: { min: 0, max: 500 },
                                          model: {
                                            value: _vm.formData.offsetTop,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "offsetTop",
                                                $$v
                                              )
                                            },
                                            expression: "formData.offsetTop",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Alttan" } },
                                      [
                                        _c("a-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: { min: 0, max: 500 },
                                          model: {
                                            value: _vm.formData.offsetBottom,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "offsetBottom",
                                                $$v
                                              )
                                            },
                                            expression: "formData.offsetBottom",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Sağdan" } },
                                      [
                                        _c("a-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: { min: 0, max: 500 },
                                          model: {
                                            value: _vm.formData.offsetRight,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "offsetRight",
                                                $$v
                                              )
                                            },
                                            expression: "formData.offsetRight",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Soldan" } },
                                      [
                                        _c("a-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: { min: 0, max: 500 },
                                          model: {
                                            value: _vm.formData.offsetLeft,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "offsetLeft",
                                                $$v
                                              )
                                            },
                                            expression: "formData.offsetLeft",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.formData.icon === "custom"
                              ? _c(
                                  "a-row",
                                  [
                                    _c(
                                      "a-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          { attrs: { label: "Özel İkon" } },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                "Özel ikon yükleme özelliği eklenecek"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a-row",
                              { attrs: { gutter: 16 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label:
                                            "'Powered by Supsis AI' yazısını gizle",
                                        },
                                      },
                                      [
                                        _c("a-switch", {
                                          model: {
                                            value:
                                              _vm.formData.hidePoweredByText,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "hidePoweredByText",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.hidePoweredByText",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "Kişisel Verileri Depolama",
                                        },
                                      },
                                      [
                                        _c("a-switch", {
                                          attrs: {
                                            "checked-children": "Hayır",
                                            "un-checked-children": "Evet",
                                          },
                                          model: {
                                            value:
                                              _vm.formData
                                                .optOutSensitiveDataStorage,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "optOutSensitiveDataStorage",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.optOutSensitiveDataStorage",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "help-text" },
                                          [
                                            _vm._v(
                                              '\n                                                Hassas konuşma verilerinin kaydedilmesini engellemek için "Hayır"\n                                                seçeneğini seçin.\n                                            '
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "settings-section" }, [
                        _c(
                          "div",
                          {
                            staticClass: "section-header",
                            class: { open: _vm.isSectionOpen("colors") },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSection("colors")
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("palette"),
                              ]),
                              _vm._v(" "),
                              _c("h3", [_vm._v("Görünüm Ayarları")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "i",
                              { staticClass: "material-icons toggle-icon" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isSectionOpen("colors")
                                      ? "keyboard_arrow_up"
                                      : "keyboard_arrow_down"
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isSectionOpen("colors"),
                                expression: "isSectionOpen('colors')",
                              },
                            ],
                            staticClass: "section-content",
                          },
                          [
                            _c(
                              "a-row",
                              { attrs: { gutter: 16 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Ana Renk" } },
                                      [
                                        _c("color-picker-item", {
                                          attrs: {
                                            title: "Ana Renk",
                                            rawColor:
                                              _vm.formData.colors.primaryColor,
                                          },
                                          model: {
                                            value:
                                              _vm.formData.colors.primaryColor,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.colors,
                                                "primaryColor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.colors.primaryColor",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Metin Rengi" } },
                                      [
                                        _c("color-picker-item", {
                                          attrs: {
                                            title: "Metin Rengi",
                                            rawColor:
                                              _vm.formData.colors.textColor,
                                          },
                                          model: {
                                            value:
                                              _vm.formData.colors.textColor,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.colors,
                                                "textColor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.colors.textColor",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Arkaplan Rengi" } },
                                      [
                                        _c("color-picker-item", {
                                          attrs: {
                                            title: "Arkaplan Rengi",
                                            rawColor:
                                              _vm.formData.colors
                                                .backgroundColor,
                                          },
                                          model: {
                                            value:
                                              _vm.formData.colors
                                                .backgroundColor,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.colors,
                                                "backgroundColor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.colors.backgroundColor",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-divider",
                              { attrs: { orientation: "left" } },
                              [_vm._v("Gelişmiş Renk Ayarları")]
                            ),
                            _vm._v(" "),
                            _c("p", [
                              _c(
                                "a",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showAdvancedColors =
                                        !_vm.showAdvancedColors
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", {
                                    attrs: {
                                      type: _vm.showAdvancedColors
                                        ? "up"
                                        : "down",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.showAdvancedColors
                                          ? "Gelişmiş renk ayarlarını gizle"
                                          : "Gelişmiş renk ayarlarını göster"
                                      ) +
                                      "\n                                    "
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.showAdvancedColors
                              ? _c(
                                  "div",
                                  [
                                    _c("h4", [_vm._v("Buton Renkleri")]),
                                    _vm._v(" "),
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "Buton Arkaplan",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "Buton Arkaplan",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .buttonBackgroundColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .buttonBackgroundColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "buttonBackgroundColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.buttonBackgroundColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: { label: "Buton Metin" },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "Buton Metni",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .buttonTextColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .buttonTextColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "buttonTextColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.buttonTextColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "Buton Hover Rengi",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "Buton Hover Rengi",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .buttonHoverBackgroundColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .buttonHoverBackgroundColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "buttonHoverBackgroundColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.buttonHoverBackgroundColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("h4", [_vm._v("Konteyner Renkleri")]),
                                    _vm._v(" "),
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "Konteyner Arkaplan",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "Konteyner Arkaplan",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .containerBackgroundColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .containerBackgroundColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "containerBackgroundColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.containerBackgroundColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "Konteyner Kenarlık",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "Konteyner Kenarlık",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .containerBorderColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .containerBorderColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "containerBorderColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.containerBorderColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("h4", [_vm._v("İkon Renkleri")]),
                                    _vm._v(" "),
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "İkon Arkaplan",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "İkon Arkaplan",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .iconBackgroundColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .iconBackgroundColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "iconBackgroundColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.iconBackgroundColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "İkon Kenarlık",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "İkon Kenarlık",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .iconBorderColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .iconBorderColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "iconBorderColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.iconBorderColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("h4", [_vm._v("Dil Seçici Renkleri")]),
                                    _vm._v(" "),
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "Dil Seçici Arkaplan",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title:
                                                      "Dil Seçici Arkaplan",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .languageSelectorBackgroundColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .languageSelectorBackgroundColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "languageSelectorBackgroundColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.languageSelectorBackgroundColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "Dil Seçici Metin",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "Dil Seçici Metin",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .languageSelectorTextColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .languageSelectorTextColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "languageSelectorTextColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.languageSelectorTextColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "Dil Seçici Kenarlık",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title:
                                                      "Dil Seçici Kenarlık",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .languageSelectorBorderColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .languageSelectorBorderColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "languageSelectorBorderColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.languageSelectorBorderColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("h4", [_vm._v("Diğer Renkler")]),
                                    _vm._v(" "),
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "Powered By Yazı",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "Powered By Yazı",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .poweredByTextColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .poweredByTextColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "poweredByTextColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.poweredByTextColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "Aktif Arama Rengi",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "Aktif Arama",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .activeCallBorderColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .activeCallBorderColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "activeCallBorderColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.activeCallBorderColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "Bağlanıyor Rengi",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "Bağlanıyor",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .connectingCallBorderColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .connectingCallBorderColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "connectingCallBorderColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.connectingCallBorderColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-row",
                                      { attrs: { gutter: 16 } },
                                      [
                                        _c(
                                          "a-col",
                                          { attrs: { span: 8 } },
                                          [
                                            _c(
                                              "a-form-item",
                                              {
                                                attrs: {
                                                  label: "Pasif Arama Rengi",
                                                },
                                              },
                                              [
                                                _c("color-picker-item", {
                                                  attrs: {
                                                    title: "Pasif Arama",
                                                    rawColor:
                                                      _vm.formData.colors
                                                        .inactiveCallBorderColor,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.colors
                                                        .inactiveCallBorderColor,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.colors,
                                                        "inactiveCallBorderColor",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.colors.inactiveCallBorderColor",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "settings-section" }, [
                        _c(
                          "div",
                          {
                            staticClass: "section-header",
                            class: { open: _vm.isSectionOpen("language") },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSection("language")
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("translate"),
                              ]),
                              _vm._v(" "),
                              _c("h3", [_vm._v("Dil Ayarları")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "i",
                              { staticClass: "material-icons toggle-icon" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isSectionOpen("language")
                                      ? "keyboard_arrow_up"
                                      : "keyboard_arrow_down"
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isSectionOpen("language"),
                                expression: "isSectionOpen('language')",
                              },
                            ],
                            staticClass: "section-content",
                          },
                          [
                            _c(
                              "a-row",
                              { attrs: { gutter: 16 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: { label: "Dil Seçiciyi Göster" },
                                      },
                                      [
                                        _c("a-switch", {
                                          model: {
                                            value:
                                              _vm.formData.showLanguageSelector,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "showLanguageSelector",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.showLanguageSelector",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Varsayılan Dil" } },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              "show-search": "",
                                              "filter-option":
                                                _vm.filterLanguageOption,
                                            },
                                            model: {
                                              value:
                                                _vm.formData.defaultLanguage,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "defaultLanguage",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.defaultLanguage",
                                            },
                                          },
                                          _vm._l(
                                            _vm.languageOptions,
                                            function (language) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: language.id,
                                                  attrs: { value: language.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(language.name) +
                                                      " (" +
                                                      _vm._s(language.id) +
                                                      ")\n                                                "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.formData.showLanguageSelector
                              ? _c(
                                  "a-row",
                                  [
                                    _c(
                                      "a-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "Kullanılabilir Diller",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select",
                                              {
                                                attrs: {
                                                  mode: "multiple",
                                                  "show-search": "",
                                                  "filter-option":
                                                    _vm.filterLanguageOption,
                                                  placeholder:
                                                    "Diller seçin...",
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .availableLanguages,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "availableLanguages",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.availableLanguages",
                                                },
                                              },
                                              _vm._l(
                                                _vm.languageOptions,
                                                function (language) {
                                                  return _c(
                                                    "a-select-option",
                                                    {
                                                      key: language.id,
                                                      attrs: {
                                                        value: language.id,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            language.name
                                                          ) +
                                                          " (" +
                                                          _vm._s(language.id) +
                                                          ")\n                                                "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "settings-section" }, [
                        _c(
                          "div",
                          {
                            staticClass: "section-header",
                            class: { open: _vm.isSectionOpen("pages") },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSection("pages")
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("filter_list"),
                              ]),
                              _vm._v(" "),
                              _c("h3", [_vm._v("Sayfa Kısıtlamaları")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "i",
                              { staticClass: "material-icons toggle-icon" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isSectionOpen("pages")
                                      ? "keyboard_arrow_up"
                                      : "keyboard_arrow_down"
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isSectionOpen("pages"),
                                expression: "isSectionOpen('pages')",
                              },
                            ],
                            staticClass: "section-content",
                          },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label:
                                    "Whitelist Sayfalar (Bu sayfalarda göster)",
                                },
                              },
                              [
                                _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      mode: "tags",
                                      placeholder:
                                        "Örn: /home, /contact, *.blog/*",
                                    },
                                    model: {
                                      value: _vm.formData.whitelistPages,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "whitelistPages",
                                          $$v
                                        )
                                      },
                                      expression: "formData.whitelistPages",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "*" } },
                                      [_vm._v("Tüm sayfalar (*)")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "help-text" }, [
                                  _vm._v(
                                    "\n                                        Boş bırakılırsa veya * eklenirse tüm sayfalarda gösterilir. Wildcard\n                                        kullanabilirsiniz: /blog/*, *.html\n                                    "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label:
                                    "Blacklist Sayfalar (Bu sayfalarda gösterme)",
                                },
                              },
                              [
                                _c("a-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    mode: "tags",
                                    placeholder:
                                      "Örn: /admin, /checkout, /payment",
                                  },
                                  model: {
                                    value: _vm.formData.blacklistPages,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "blacklistPages",
                                        $$v
                                      )
                                    },
                                    expression: "formData.blacklistPages",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "help-text" }, [
                                  _vm._v(
                                    "Wildcard kullanabilirsiniz: /admin/*, *.php"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "settings-section" }, [
                        _c(
                          "div",
                          {
                            staticClass: "section-header",
                            class: { open: _vm.isSectionOpen("domains") },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSection("domains")
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("domain"),
                              ]),
                              _vm._v(" "),
                              _c("h3", [_vm._v("Domain Kısıtlamaları")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "i",
                              { staticClass: "material-icons toggle-icon" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isSectionOpen("domains")
                                      ? "keyboard_arrow_up"
                                      : "keyboard_arrow_down"
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isSectionOpen("domains"),
                                expression: "isSectionOpen('domains')",
                              },
                            ],
                            staticClass: "section-content",
                          },
                          [
                            _c(
                              "a-form-item",
                              { attrs: { label: "İzin Verilen Domainler" } },
                              [
                                _c("a-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    mode: "tags",
                                    placeholder:
                                      "Örn: example.com, *.yourdomain.com",
                                  },
                                  model: {
                                    value: _vm.formData.allowedDomains,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "allowedDomains",
                                        $$v
                                      )
                                    },
                                    expression: "formData.allowedDomains",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "help-text" }, [
                                  _vm._v(
                                    "\n                                        Boş bırakılırsa tüm domainlerden erişime izin verilir. Wildcard\n                                        kullanabilirsiniz: *.example.com\n                                    "
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "settings-section" }, [
                        _c(
                          "div",
                          {
                            staticClass: "section-header",
                            class: { open: _vm.isSectionOpen("code") },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSection("code")
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "section-title" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("code"),
                              ]),
                              _vm._v(" "),
                              _c("h3", [_vm._v("Entegrasyon Kodu")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "i",
                              { staticClass: "material-icons toggle-icon" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.isSectionOpen("code")
                                      ? "keyboard_arrow_up"
                                      : "keyboard_arrow_down"
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isSectionOpen("code"),
                                expression: "isSectionOpen('code')",
                              },
                            ],
                            staticClass: "section-content",
                          },
                          [
                            _c("p", [
                              _vm._v(
                                "\n                                    Aşağıdaki kodu web sitenizin "
                              ),
                              _c("code", [_vm._v("<body>")]),
                              _vm._v(
                                " etiketinin kapanışından\n                                    önce ekleyin:\n                                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "code-block" },
                              [
                                _c("pre", [
                                  _c("code", [
                                    _vm._v(
                                      '<script src="' +
                                        _vm._s(_vm.voiceAgentUrl) +
                                        "/setup.js?t=" +
                                        _vm._s(_vm.timestamp) +
                                        '" type="text/javascript" async defer id="supsis-ai-web-voice-agent" site-id="' +
                                        _vm._s(_vm.siteId) +
                                        '" agent-id="' +
                                        _vm._s(_vm.agent.agent_id) +
                                        '"></script>'
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    staticClass: "copy-btn",
                                    attrs: { type: "primary", icon: "copy" },
                                    on: { click: _vm.copyCode },
                                  },
                                  [
                                    _vm._v(
                                      "Kopyala\n                                    "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-actions" },
                        [
                          _c(
                            "PermissionController",
                            { attrs: { permissions: ["voice-agent.update"] } },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.isSaving,
                                  },
                                  on: { click: _vm.saveSettings },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Kaydet\n                                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "settings-preview-container" }, [
                _c(
                  "div",
                  { staticClass: "settings-preview" },
                  [
                    _c("web-agent-preview", {
                      attrs: { settings: _vm.formData },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "features" }, [
      _c("h4", [_vm._v("Özellikler:")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("i", { staticClass: "material-icons" }, [_vm._v("check_circle")]),
          _vm._v(
            " Ziyaretçiler ses ile AI ajanınızla\n                            konuşabilir\n                        "
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", { staticClass: "material-icons" }, [_vm._v("check_circle")]),
          _vm._v(" Birden fazla dil desteği"),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", { staticClass: "material-icons" }, [_vm._v("check_circle")]),
          _vm._v(
            " Özelleştirilebilir görünüm ve konumlandırma\n                        "
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", { staticClass: "material-icons" }, [_vm._v("check_circle")]),
          _vm._v(
            " Sayfa bazlı filtreleme (whitelist/blacklist)\n                        "
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", { staticClass: "material-icons" }, [_vm._v("check_circle")]),
          _vm._v(" İzin verilen alan adı kısıtlaması"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }